import { customAxios } from '../index';

import type {
  UserSnsConnection,
  CreateUserSnsConnectionRequest,
  UpdateUserSnsConnectionRequest,
} from '../../interface/I_userSnsConnection';

const fetchByUser = async (uuid: string): Promise<UserSnsConnection[]> =>
  customAxios.get(`/hktv_koc/cms/user_sns_connections/user/${uuid}`);

const add = async (data: CreateUserSnsConnectionRequest): Promise<UserSnsConnection> =>
  customAxios.post('/hktv_koc/cms/user_sns_connections', data);

const edit = async (id: number, data: UpdateUserSnsConnectionRequest): Promise<UserSnsConnection> =>
  customAxios.put(`/hktv_koc/cms/user_sns_connections/${id}`, data);

const deleteSns = async (id: number): Promise<void> =>
  customAxios.delete(`/hktv_koc/cms/user_sns_connections/${id}`);

export default {
  fetchByUser,
  add,
  edit,
  delete: deleteSns,
};
